"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationMarker = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
;
function LocationMarker({ size: startSize }) {
    const size = (0, react_1.useMemo)(() => startSize || 40, [startSize]);
    return ((0, jsx_runtime_1.jsxs)("div", { style: {
            filter: "drop-shadow(1px 2px 2px #00000099)",
            width: size,
            height: size,
            transform: `translateY(-100%) translateX(-50%)`,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }, children: [(0, jsx_runtime_1.jsx)("i", { className: "bi bi-geo-alt-fill text-primary", style: {
                    fontSize: size,
                    filter: "drop-shadow(0px 0px 1px #00000066)",
                } }), (0, jsx_runtime_1.jsx)("div", { style: {
                    width: size * 0.5,
                    height: size * 0.5,
                    backgroundColor: "white",
                    borderRadius: "50%",
                    position: "absolute",
                    top: size * 0.1,
                    zIndex: -1
                } })] }));
}
exports.LocationMarker = LocationMarker;
